import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { Differentiator } from '../components/Differentiator';
import { HowItWorks } from '../components/HowItWorks';
import { ComparisonTable } from '../components/ComparisonTable';
import { PricingSection } from '../components/PricingSection';
import { CalculatorSection } from '../components/CalculatorSection';
import { CourseSection } from '../components/CourseSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-100 selection:text-brand-900" data-id="element-435">
      <Navbar data-id="element-436" />
      <main data-id="element-437">
        <Hero data-id="element-438" />
        <ProblemSection data-id="element-439" />
        <Differentiator data-id="element-440" />
        <HowItWorks data-id="element-441" />
        <ComparisonTable data-id="element-442" />
        <PricingSection data-id="element-443" />
        <CalculatorSection data-id="element-444" />
        <CourseSection data-id="element-445" />
        <FinalCTA data-id="element-446" />
      </main>
      <Footer data-id="element-447" />
    </div>;
}